// @examforge/shared/i18n — UI string dictionary
//
// Decision (2026-05-03, Session 19A):
// - Single flat key namespace (e.g. "nav.dashboard", "form.step1.title").
// - Two locale dictionaries: zh (default) and en.
// - Lookup is strict: missing keys throw in dev, fall back to key string in prod.
// - Default locale is "zh" — see CLAUDE.md §0a + MANIFESTO §1.2 (Chinese-default UI).
//
// Why a flat key namespace instead of nested objects:
// - Easier to grep across the codebase ("which strings reference X?")
// - Dictionary keys are union-typed so TypeScript catches typos at compile time
// - Component authors add new keys to BOTH dictionaries; mismatch is a type error
export const SUPPORTED_LOCALES = ['zh', 'en'];
export const DEFAULT_LOCALE = 'zh';
//# sourceMappingURL=dictionary.js.map